import request from "@/utils/request";
import config from "@/utils/config";
import {
    handleUrlEncode
} from "@/utils/urlutil";

/**
 * 后台分页获取所有系统举报原因分类集合
 * @param param
 * @returns {*}
 */
export function getAppReportCategoryList(param) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminAppReport/Category/List",
        method: "get",
        params: param,
    })
}

/**
 * 更新系统举报原因分类信息
 * @param data
 * @returns {*}
 */
export function updateAppReportCategory(data) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminAppReport/Category/Update",
        method: "post",
        data,
    })
}

/**
 * 删除或者恢复系统举报原因分类信息
 * @param param
 * @returns {*}
 */
export function appReportCategoryDeleteOrBack(data) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminAppReport/Category/DeleteOrBack",
        method: "post",
        data,
    })
}

/**
 * 添加系统举报原因分类
 * @param data
 * @returns {*}
 */
export function addAppReportCategory(data) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminAppReport/Category/Add",
        method: "post",
        data,
    })
}

/**
 * 后台分页获取所有举报记录列表
 * @param param
 * @returns {*}
 */
export function getAppReportList(param) {
    let url = config.API_ADMIN + "/Api/V1/AdminAppReport/List?";
    url = handleUrlEncode(url, param)
    return request({
        url: url,
        method: "get",
    })
}

/**
 * 删除或者恢复系统举报记录
 * @param param
 */
export function appReportDeleteOrBack(data) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminAppReport/DeleteOrBack",
        method: "post",
        data,
    })
}

/**
 * 后台审核举报信息
 * @param data
 * @returns {*}
 */
export function auditAppReport(data) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminAppReport/Audit",
        method: "post",
        data,
    })
}